/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Menu } from 'Components/Menu';
import { useTheme } from '@material-ui/core/styles';

export const MoreButton = () => {
  const theme = useTheme();

  return (
    <Menu
      menuItems={[
        {
          iconUrl: '/img/rarible-logo.svg',
          iconAlt: 'Rarible Logo',
          text: 'View on Rarible',
          href: 'https://rarible.com/token/123:456',
        },
        {
          iconUrl: '/img/opensea-logo.svg',
          iconAlt: 'OpenSea Logo',
          text: 'View on OpenSea',
          href: 'https://opensea.io/assets/123/456',
        },
      ]}
    >
      <img
        src="/img/more.png"
        alt="more button"
        css={css`
          width: 20px;
          margin-left: 10px;
          ${theme.breakpoints.up('sm')} {
            width: 27px;
          }
        `}
      />
    </Menu>
  );
};
